import { SidebarUserMenu } from "./SidebarUserMenu";
import type { MyProfileResponse } from "@/entities/employee/model/types";

type UserShellProps = {
  children: React.ReactNode;
  currentUser: MyProfileResponse | undefined;
};

export function UserShell({ children, currentUser }: UserShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="flex h-[52px] shrink-0 items-center justify-between border-b border-line bg-surface px-4">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white p-1 ring-1 ring-black/5">
          <img
            src="/logo-mark.svg"
            alt="Neztrack"
            className="h-full w-full object-contain"
          />
        </span>
        <SidebarUserMenu currentUser={currentUser} />
      </header>
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
